import React from 'react';
import { Grid } from '@mui/material';
import { DatePicker } from 'components/LegacyPickers';
import jMoment from 'moment-jalaali';
import persianJs from 'persianjs';
import { DatePickerPod, InputV2 } from 'components';

const DateFieldWrapper = ({ item, methods, handleFieldValueChange }) => {
  const selectedDate = item?.selectedValue
    ? jMoment(item.selectedValue, 'jYYYY/jMM/jDD')
    : null;

  return (
    <Grid item xs={12} md={4} style={{ position: 'relative', marginBottom: '8px' }}>
      {/* این InputV2 مخفی برای ثبت مقدار در فرم است */}
      <span style={{ display: 'none' }}>
        <InputV2
          errors={methods.formState.errors}
          name={item?.name}
          label={item?.persianName}
          register={methods.register}
          control={methods.control}
          rules={item?.required ? ['required'] : []}
          forceValue={item['selectedValue']}
          defaultValue={item['selectedValue']}
        />
      </span>

      <DatePickerPod label={item.persianName} showAsterisk={item?.required}>
        <DatePicker
          style={{ marginBottom: '0 !important' }}
          variant="inline"
          autoOk
          inputVariant="outlined"
          showTodayButton
          todayLabel="امروز"
          okLabel="تایید"
          cancelLabel="لغو"
          clearLabel="پاک کردن"
          labelFunc={(date) =>
            typeof date?.format === 'function' ? date.format('jYYYY/jMM/jDD') : ''
          }
          rules={item?.required ? ['required'] : []}
          value={selectedDate?.isValid() ? selectedDate : null}
          onChange={(date) => {
            const value = date
              ? persianJs(date.format('jYYYY/jMM/jDD')).toEnglishNumber().toString()
              : '';
            methods.setValue(item.name, value);

            if (value) {
              methods.clearErrors(item.name);
            }

            handleFieldValueChange(item.id, value, 'input');
          }}
        />
      </DatePickerPod>

      {/* نمایش خطای اعتبارسنجی */}
      <span style={{ color: 'red', fontSize: '11px', position: 'absolute', marginTop: '-4px' }}>
        {methods?.errors?.[item.name]?.message}
      </span>
    </Grid>
  );
};

export default DateFieldWrapper;
